//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class TeacherPayrollOverrideSearchOptions extends ItemBase {
    Active: boolean | null = null;
    EventCategoryIDs: string[] = [];
    TeacherIDs: string[] = [];

    constructor(initializer?: Partial<TeacherPayrollOverrideSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherPayrollOverrideSearchOptions";
}
